import React from 'react';
import { Download } from 'react-feather';

const DownloadSection: React.FC = () => {
    return (
    <div id="download-section" className="gradient-bg py-16">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-3xl font-bold text-gray-900 mb-4" data-aos="fade-up">Téléchargez Le Panier Clair</h2>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-aos="fade-up" data-aos-delay="100">
                        Commencez à faire des choix plus sains et durables en quelques secondes.
                    </p>
                </div>
                
                <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-xl overflow-hidden" data-aos="zoom-in">
                    <div className="md:flex">
                        <div className="p-8 md:w-2/3">
                            <h3 className="text-2xl font-bold text-gray-900 mb-4">Ajoutez à votre navigateur</h3>
                            <p className="text-gray-600 mb-6">
                                Le Panier Clair est disponible sur tous les navigateurs majeurs. Cliquez sur votre option préférée pour installer.
                            </p>
                            
                            <div className="grid grid-cols-2 gap-4 mb-6">
                                <a href="https://chromewebstore.google.com/detail/panierclair/efnbpledehcodegblknokhihhinheojc" target="_blank" rel="noopener noreferrer" className="bg-gray-100 hover:bg-gray-200 rounded-lg p-4 flex items-center transition">
                                    <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Google_Chrome_icon_%28February_2022%29.svg/1200px-Google_Chrome_icon_%28February_2022%29.svg.png" alt="Chrome" className="h-8 w-8 mr-3" />
                                    <span>Chrome</span>
                                </a>
                                <a href="https://addons.mozilla.org/fr/firefox/addon/panierclair/" target="_blank" rel="noopener noreferrer" className="bg-gray-100 hover:bg-gray-200 rounded-lg p-4 flex items-center transition">
                                    <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Firefox_logo%2C_2019.svg/1200px-Firefox_logo%2C_2019.svg.png" alt="Firefox" className="h-8 w-8 mr-3" />
                                    <span>Firefox</span>
                                </a>
                                {/* <a href="https://microsoftedge.microsoft.com/addons/Microsoft-Edge-Extensions-Home" target="_blank" rel="noopener noreferrer" className="bg-gray-100 hover:bg-gray-200 rounded-lg p-4 flex items-center transition">
                                    <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Microsoft_Edge_logo_%282019%29.svg/1200px-Microsoft_Edge_logo_%282019%29.svg.png" alt="Edge" className="h-8 w-8 mr-3" />
                                    <span>Edge</span>
                                </a>
                                <a href="https://apps.apple.com/fr/app/safari-extensions/id1438243180" target="_blank" rel="noopener noreferrer" className="bg-gray-100 hover:bg-gray-200 rounded-lg p-4 flex items-center transition">
                                    <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Safari_browser_logo.svg/1200px-Safari_browser_logo.svg.png" alt="Safari" className="h-8 w-8 mr-3" />
                                    <span>Safari</span>
                                </a> */}
                            </div>
                            
                            <div className="text-sm text-gray-500">
                                <p>En installant, vous acceptez nos <a href="/terms-of-use" className="text-green-600 hover:underline">Conditions d'utilisation</a> et notre <a href="/privacy-policy" className="text-green-600 hover:underline">Politique de confidentialité</a>.</p>
                            </div>
                        </div>
                        <div className="bg-green-600 md:w-1/3 flex items-center justify-center p-8">
                            <div className="text-white text-center">
                                <Download className="w-12 h-12 mb-4 mx-auto" />
                                <h3 className="text-xl font-bold mb-2">100% Gratuit</h3>
                                <p>Aucun frais caché ni abonnement. Nous pensons que ces informations doivent être accessibles à tous.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DownloadSection;